import moment from 'moment';
import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
import Configuration from '@/utils/configuration';
import { handleApiError, deleteDataCache } from '@/utils/helpers';

const API_HOST = Configuration.value('VUE_APP_API_HOST');

export const listParticipated = async (userId, timeline) => {
  let response = {};

  try {
    response = await axiosInstance.get(`/evnparticipant/participant/${userId}`);

    if (response.data === null) {
      response.data = [];
    }

    const totalEvents = response.data ? response.data.length : 0;

    switch (timeline) {
      case 'past':
        response.data = response.data.filter((event) => {
          return moment(event.event.endsAt).isBefore(moment());
        });
        break;
      case 'present':
        response.data = response.data.filter((event) => {
          return (
            moment(event.event.startsAt).isBefore(moment()) &&
            moment(event.event.endsAt).isAfter(moment())
          );
        });
        break;
      case 'future':
        response.data = response.data.filter((event) => {
          return moment(event.event.startsAt).isAfter(moment());
        });
        break;
      default:
        break;
    }
    response.totalEvents = totalEvents;

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const listAll = async (timeline) => {
  let response = {};

  try {
    response = await axiosInstance.get(`/events`);
    const totalEvents = response.data ? response.data.length : 0;

    switch (timeline) {
      case 'past':
        response.data = response.data.filter((event) => {
          return moment(event.endsAt).isBefore(moment());
        });
        break;
      case 'present':
        response.data = response.data.filter((event) => {
          return (
            moment(event.startsAt).isBefore(moment()) && moment(event.endsAt).isAfter(moment())
          );
        });
        break;
      case 'future':
        response.data = response.data.filter((event) => {
          return moment(event.startsAt).isAfter(moment());
        });
        break;
      default:
        break;
    }
    response.data.totalEvents = totalEvents;

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const list = async (timeline) => {
  try {
    const response = await axiosInstance.get(`/me/events`);

    switch (timeline) {
      case 'past':
        response.data = response.data.filter((event) => {
          return moment(event.endsAt).isBefore(moment());
        });
        break;
      case 'present':
        response.data = response.data.filter((event) => {
          return (
            moment(event.startsAt).isBefore(moment()) && moment(event.endsAt).isAfter(moment())
          );
        });
        break;
      case 'future':
        response.data = response.data.filter((event) => {
          return moment(event.startsAt).isAfter(moment());
        });
        break;
      default:
        break;
    }

    response.status = 200;

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const listClubhouseEvents = async (id, timeline) => {
  let response = {};

  try {
    response = await axiosInstance.get(`/clubhouse/${id}/events`);
    const totalEvents = response.data ? response.data.length : 0;

    if (response.data !== null && response.data !== '') {
      switch (timeline) {
        case 'past':
          response.data = response.data.filter((event) => {
            return moment(event.endsAt).isBefore(moment());
          });
          break;
        case 'present':
          response.data = response.data.filter((event) => {
            return (
              moment(event.startsAt).isBefore(moment()) && moment(event.endsAt).isAfter(moment())
            );
          });
          break;
        case 'future':
          response.data = response.data.filter((event) => {
            return moment(event.startsAt).isAfter(moment());
          });
          break;
        case 'all':
          // response.data = response.data;
          break;
        default:
          break;
      }
    }
    response.totalEvents = totalEvents;

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const show = async (id, overrideCache = false) => {
  let response = {};

  // ttl: 1000 * 60 * 60 * 4, // 4 hours
  // let ttlTime = 1000 * 60 * 15; // 15 min
  const ttlTime = 1000 * 60 * 5; // 5 min

  // if (overrideCache) {
  //   ttlTime = 1000 * 60 * 0.5;
  //   // await deleteDataCache(axiosInstanceCached, true, `event_${id}`);
  // }

  try {
    response = await axiosInstanceCached.get(`/event/${id}`, {
      id: `event-${id}`,
      cache: {
        ttl: ttlTime,
        // override: overrideCache,
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const create = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.post(`${API_HOST}/event/create`, payload);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* update event information
export const updateEvent = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.patch(`/event/${payload.id}`, payload);
    //* delete cache event-${id}
    await deleteDataCache(axiosInstanceCached, true, `event-${payload.id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* delete individual event for clubhouse
export const deleteEvent = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.delete(`/event/${payload.id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ param rankBy=score to adjust sorting. Default is rankBy=thru but don't need to pass that
export const leaderboard = async (
  id,
  overrideCache = false,
  sortScore = false,
  toggled = false
) => {
  let response = {};

  if (overrideCache || sortScore || toggled) {
    await deleteDataCache(axiosInstanceCached, true, `leaderboard_${id}`);
  }

  const url = `/event/${id}/leaderboard${sortScore ? `?rankBy=score` : ''}`;
  try {
    response = await axiosInstanceCached.get(url, {
      id: `leaderboard_${id}${sortScore ? '_rankByScore' : ''}`,
      cache: {
        ttl: 1000 * 60 * 15,
        // override: overrideCache,
        // update: {
        //   [`event-${id}`]: 'delete',
        // },
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ {
// @ 	"user_ids": ["3f1effe0-aeb1-4b7f-ad89-7ab0ced1e9f111"],
// @   "round_id": "4f27dbb5-8dd0-4f4e-80fe-58055ff26a46111",
// @   "edited_score": 12
// @ }
export const updateLeaderboardScore = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.put(`/event/${payload.eventID}/leaderboard`, payload);
    await deleteDataCache(axiosInstanceCached, true, `leaderboard_${payload.eventID}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
